document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[is="open-mobile-drawer"]');

  if (!trigger) return;

  event.preventDefault();

  const menuButton = document.querySelector(
    '.wt-header .wt-header__menu-trigger'
  );

  if (menuButton) {
    menuButton.click();
  }
});

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[is="open-search-drawer"]');

  if (!trigger) return;

  event.preventDefault();

  const searchButton = document.querySelector(
    '.wt-header__search-trigger'
  );

  if (searchButton) {
    searchButton.click();
  }
});

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('#mobile-cart-icon-bubble');

  if (!trigger) return;

  event.preventDefault();

  const cartButton = document.querySelector(
    '.wt-cart__trigger'
  );

  if (cartButton) {
    cartButton.click();
  }
});


(function () {
  let updating = false;
  let updateAgain = false;

  async function syncMobileCart() {
    if (updating) {
      updateAgain = true;
      return;
    }

    updating = true;

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${root}cart.js`, {
        cache: 'no-store'
      });

      if (!response.ok) return;

      const cart = await response.json();
      const count = cart.item_count;

      const mobileCart = document.querySelector(
        '#mobile-cart-icon-bubble'
      );

      if (!mobileCart) return;

      let bubble = mobileCart.querySelector('.cart-count-bubble');

      mobileCart.classList.toggle('is-empty-cart', count === 0);

      const icon = mobileCart.querySelector('.svg-wrapper');
      icon?.classList.toggle('empty-cart', count === 0);

      if (count === 0) {
        bubble?.remove();
        return;
      }

      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = `
          <span aria-hidden="true" data-total-cart-item></span>
          <span class="visually-hidden"></span>
        `;

        if (icon) {
          icon.after(bubble);
        } else {
          mobileCart.prepend(bubble);
        }
      }

      bubble.querySelector('[data-total-cart-item]').textContent = count;

      bubble.querySelector('.visually-hidden').textContent =
        `${count} ${count === 1 ? 'item' : 'items'}`;

    } catch (error) {
      console.error('Mobile cart sync error:', error);
    } finally {
      updating = false;

      if (updateAgain) {
        updateAgain = false;
        syncMobileCart();
      }
    }
  }

  // Listen to common Shopify theme cart events
  [
    'cart:updated',
    'cart:update',
    'cart:refresh',
    'cart:change',
    'cart:build',
    'cart:added',
    'product:added',
    'ajaxProduct:added'
  ].forEach(eventName => {
    document.addEventListener(eventName, syncMobileCart);
  });

  // Observe cart changes in the theme's header
  const observer = new MutationObserver(() => {
    clearTimeout(window.mobileCartSyncTimer);

    window.mobileCartSyncTimer = setTimeout(
      syncMobileCart,
      150
    );
  });

  function init() {
    const header = document.querySelector(
      'header, .header-wrapper, #shopify-section-header'
    );

    if (header) {
      observer.observe(header, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    syncMobileCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', syncMobileCart);
  window.addEventListener('pageshow', syncMobileCart);
})();
